module.exports = __webpack_public_path__ + "static/media/menuGift.49f5925f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuGift.svg
// module id = 470
// module chunks = 0